module.exports = __webpack_public_path__ + "static/3A841E_4_0-807be56c80f37b5e087654ae6e9ff328.svg";